/* 布局 */
//前台
import Layout from "@views/layout";

const noticRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "notic/list",
        name: "NOTIC",
        meta: {
            title: "公告管理",
            keepAlive:true
        },
        component: () => import("@views/business/notic/index.vue"),
    },
        ],
};

export default noticRouter;
